import React, { useEffect, useState } from 'react'
import styles from './ModalLaboratoryResult.module.css'
import { CheckIcon } from '@heroicons/react/24/outline';

function ModalLaboratoryResult({ onClose, data }) {

    // const [dataNewList, setDataNewList] = useState([])

    const styles_tailwind = {
        icon: 'h-[25px] stroke-[#374957] stroke-[2px] m-auto',
        btn_close: 'text-[#526F65] font-bold text-center hover:cursor-pointer my-5'
    }

    // useEffect(() => {
        // console.log(data)
        // const dataList = [data[0], data[1], data[2], data[3]]
    // }, [])

    return (
        <div className={styles.overlay}>
            <div className={styles.modalController}>
                <div className={styles.closeButton}>
                    {/* <img onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img> */}
                </div>
                <div className={styles.contentModal}>
                    <div className={styles.title}>สรุปผลการตรวจยัน</div>
                    <div className={styles.align}>
                        <table className={styles.table}>
                            <thead>
                                <tr className={styles.tr}>
                                    <th className={`${styles.th} font-bold`} style={{ borderLeft: 'none', borderBottom: '1px solid #ff9768' }}>Lab</th>
                                    <th className={`${styles.th} font-bold`} style={{ borderBottom: '1px solid #ff9768' }}>Result</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.slice(0,4).map((i, idx) => {
                                    return (
                                        <>
                                            <tr className={styles.tr} key={idx}>
                                                <td className={styles.td} style={{ fontWeight: 600, borderLeft: 'none' }}>{i['lab_classify']['lab_result']['lab_name']}</td>
                                                <td className={styles.td}>
                                                    <div
                                                        className={
                                                            i['lab_classify']['lab_result']['result']['result_key'] === 'negative' ? `${styles.negative}`
                                                                : i['lab_classify']['lab_result']['result']['result_key'] === 'positive' ? `${styles.positive} `
                                                                    : i['lab_classify']['lab_result']['result']['result_key'] === 'rapid_acetylator' ? `${styles.rapidInter} `
                                                                        : i['lab_classify']['lab_result']['result']['result_key'] === 'slow_acetylator' ? `${styles.slowAcetylator} `
                                                                            : `${styles.intermediate}`
                                                        }
                                                    >
                                                        {
                                                            i['lab_classify']['lab_result']['result']['result_name']
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })}
                            </tbody>
                        </table>
                        {/* <table className={styles.table}>
                            <thead>
                                <tr className={styles.tr}>
                                    <th className={styles.td} style={{ borderLeft: 'none' }}>ชื่อการตรวจยีน</th>
                                    <th className={styles.td}>Slow</th>
                                    <th className={styles.td}>Intermidiate</th>
                                    <th className={styles.td}>Rapid</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.filter(item => {
                                        return item['expr2'].includes('NAT2-diplotype')
                                    }).map((i, idx) => {
                                        return (
                                            <>
                                                <tr className={styles.tr} key={idx}>
                                                    <td className={styles.td} style={{ fontWeight: 600, borderLeft: 'none' }}>{i['lab_classify']['lab_result']['lab_name']}</td>
                                                    <td className={styles.td}>
                                                        {
                                                            i['lab_classify']['lab_result']['result']['result_key'] === 'slow_acetylator' ? <CheckIcon className={styles_tailwind.icon} /> : <div></div>
                                                        }
                                                    </td>
                                                    <td className={styles.td}>
                                                        {
                                                            i['lab_classify']['lab_result']['result']['result_key'] === 'intermediate_acetylator' ? <CheckIcon className={styles_tailwind.icon} /> : <div></div>
                                                        }
                                                    </td>
                                                    <td className={styles.td}>
                                                        {
                                                            i['lab_classify']['lab_result']['result']['result_key'] === 'rapid_acetylator' ? <CheckIcon className={styles_tailwind.icon} /> : <div></div>
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>
                        </table> */}
                    </div>
                </div>

                <div className={styles_tailwind.btn_close} onClick={() => { onClose() }}>ปิดหน้าต่างนี้</div>
            </div>
        </div>
    )
}
export default ModalLaboratoryResult